/**
 * The window a full-page navigation belongs to.
 *
 * Normally this window. Inside the operator view's iPad stage (z8nrz7g204,
 * `src/mobile/components/TabletStage.tsx`) the app runs in a same-origin
 * frame, and some navigations are for the page holding it: a switch of view,
 * or a sign-in provider, which refuses to be shown in a frame.
 */
export function topWindow(): Window {
  try {
    if (window.top && window.top !== window.self && window.top.location.origin === window.location.origin) {
      return window.top
    }
  } catch {
    // A cross-origin parent: not ours, stay in this window.
  }
  return window
}

/** True inside a same-origin frame (the iPad stage). */
export function isFramed(): boolean {
  return topWindow() !== window
}
